module.exports = __webpack_public_path__ + "img/金属材料学7_2.a2b3802d.png";